/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SubcontractorCreationRequest } from './';
import {
    SubcontractorCreationRequestFromJSON,
    SubcontractorCreationRequestFromJSONTyped,
    SubcontractorCreationRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface CheckSubcontractorForExistingAccountRequest
 */
export interface CheckSubcontractorForExistingAccountRequest {
    /**
     * 
     * @type {SubcontractorCreationRequest}
     * @memberof CheckSubcontractorForExistingAccountRequest
     */
    subcontractor: SubcontractorCreationRequest;
}

/**
 * Check if a given object implements the CheckSubcontractorForExistingAccountRequest interface.
 */
export function instanceOfCheckSubcontractorForExistingAccountRequest(value: object): value is CheckSubcontractorForExistingAccountRequest {
    if (!('subcontractor' in value) || value['subcontractor'] === undefined) return false;
    return true;
}

export function CheckSubcontractorForExistingAccountRequestFromJSON(json: any): CheckSubcontractorForExistingAccountRequest {
    return CheckSubcontractorForExistingAccountRequestFromJSONTyped(json, false);
}

export function CheckSubcontractorForExistingAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckSubcontractorForExistingAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'subcontractor': SubcontractorCreationRequestFromJSON(json['subcontractor']),
    };
}

export function CheckSubcontractorForExistingAccountRequestToJSON(value?: CheckSubcontractorForExistingAccountRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'subcontractor': SubcontractorCreationRequestToJSON(value['subcontractor']),
    };
}

